import Steps from './Steps';
import Step from './Step';

Steps.Step = Step;

export { Step };
export default Steps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-steps@3.1.1@rc-steps/es/index.js
// module id = 648
// module chunks = 0 1